import { css } from 'emotion';

import { defaultLink } from './defaultLink';
import { gutter } from '../../margins';
import {
  minWidth,
  tablet,
  desktopMedium,
  desktopLarge,
} from '../../screenSizes';

const marginSides = margin => css`
  margin: 0 ${margin};

  &:last-child {
    margin-right: calc(${margin} * 2);
  }
`;

export const navigationLink = css`
  display: block;
  margin: 0 calc(${gutter} / 2);
  text-transform: uppercase;
  font-weight: 700;

  &:first-child {
    margin-left: 0;
  }

  &:last-child {
    margin-right: 0;
  }

  ${minWidth(tablet)} {
    ${marginSides('30px')};
  }

  ${minWidth(desktopMedium)} {
    ${marginSides('40px')};
  }

  ${minWidth(desktopLarge)} {
    ${marginSides('50px')};
  }

  ${defaultLink};
`;



// WEBPACK FOOTER //
// ./app/components/Navigation/navigationLink.js